import { StatsCardProps } from "Components/Common/StatsCard";
import StatsGroup from "Components/Common/StatsGroup";
import React from "react";

import {
  DropdownItem,
  DropdownMenu,
  DropdownToggle,
  UncontrolledDropdown,
} from "reactstrap";
import { ClientDetailsPayload } from "types/client.api";
import { getTwoLetters } from "utils/utils";

const buildClientStats = (client: ClientDetailsPayload): StatsCardProps[] => [
  {
    title: "TOTAL QUOTES",
    icon: "BigBlueReceipt",
    value: client.total_quotes,
    suffix: "",
    prefix: "",
    separator: ",",
    decimal: 0,
  },
  {
    title: "QUOTES ACCEPTED",
    icon: "BigGreenTickMark",
    value: client.quote_accepted_count, // or accepted count if you have
    suffix: "",
    prefix: "",
    separator: ",",
    decimal: 0,
  },
  {
    title: "TOTAL INVOICES",
    icon: "BigBlueReceipt",
    value: client.total_invoices,
    suffix: "",
    prefix: "",
    separator: ",",
    decimal: 0,
  },
  {
    title: "OUTSTANDING BALANCE",
    icon: "BigRedCurrency",
    value: client.total_invoices_amount,
    suffix: "",
    prefix: "£",
    separator: ",",
    decimal: 2,
  },
  {
    title: "AVAILABLE CREDIT",
    icon: "BigGreenCurrency",
    value: client.available_credit || 0,
    suffix: "",
    prefix: "£",
    separator: ",",
    decimal: 2,
  },
];

interface ClientDetailsHeaderProps {
  onclickDelete: (contactData: any) => void;
  handleContactClick: (contactData: any) => void;
  onClickEdit: (contactData: any) => void;
  clientData: ClientDetailsPayload;
}

const ClientDetailsHeader: React.FC<ClientDetailsHeaderProps> = ({
  onClickEdit,
  onclickDelete,
  handleContactClick,
  clientData,
}) => {
  const stats = buildClientStats(clientData);

  return (
    <React.Fragment>
      <div className="d-flex flex-column flex-lg-row gap-3 align-items-stretch w-100">
        {/* Left Card */}
        <div className="w-25 w-md-60">
          <div className="card h-100 w-100 br-10">
            <div className="card-body d-flex flex-column justify-content-center">
              <div className="d-flex gap-3 align-items-center">
                <div
                  style={{
                    width: 63,
                    height: 63,
                    borderRadius: 100,
                    backgroundColor: "#ECF0FE",
                    display: "grid",
                    placeItems: "center",
                    flexShrink: 0,
                  }}
                >
                  <div className="fw-medium fs-14 text-blue">
                    {getTwoLetters(clientData?.name || "NA")}
                  </div>
                </div>

                <div className="flex-grow-1" style={{ minWidth: 0 }}>
                  <h5
                    className="fs-15 mb-1"
                    style={{
                      display: "-webkit-box",
                      WebkitLineClamp: 2,
                      WebkitBoxOrient: "vertical",
                      overflow: "hidden",
                      wordBreak: "break-word",
                      overflowWrap: "break-word",
                    }}
                  >
                    {clientData?.name || "NA"}
                  </h5>
                  <p
                    className="mb-0 text-muted"
                    style={{
                      display: "-webkit-box",
                      WebkitLineClamp: 2,
                      WebkitBoxOrient: "vertical",
                      overflow: "hidden",
                      wordBreak: "break-word",
                      overflowWrap: "break-word",
                    }}
                  >
                    {clientData?.company_name}
                  </p>
                </div>

                <ul className="list-inline hstack gap-2 mb-0">
                  <li className="list-inline-item">
                    <UncontrolledDropdown className="float-end">
                      <DropdownToggle
                        className="btn btn-soft-secondary btn-sm dropdown"
                        tag="button"
                      >
                        <i className="ri-more-fill align-middle"></i>
                      </DropdownToggle>

                      <DropdownMenu
                        className="dropdown-menu-end"
                        container="body"
                      >
                        <DropdownItem onClick={handleContactClick}>
                          <i className="ri-phone-line align-bottom me-2 text-muted"></i>
                          Contact Info
                        </DropdownItem>

                        <DropdownItem onClick={() => onClickEdit(clientData)}>
                          <i className="ri-pencil-fill align-bottom me-2 text-muted"></i>
                          Edit
                        </DropdownItem>

                        <DropdownItem onClick={() => onclickDelete(clientData)}>
                          <i className="ri-delete-bin-fill align-bottom me-2 text-muted"></i>
                          Delete
                        </DropdownItem>
                      </DropdownMenu>
                    </UncontrolledDropdown>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>

        {/* Right Stats Card */}
        <div className="flex-fill w-100 w-lg-60">
          <div className="card h-100 br-10">
            <div className="card-body p-0">
              <div className="d-flex h-100">
                <StatsGroup items={stats} />
              </div>
            </div>
          </div>
        </div>
      </div>
    </React.Fragment>
  );
};

export default React.memo(ClientDetailsHeader);
